import { render, staticRenderFns } from "./consultar-legajos.vue?vue&type=template&id=4b20513e&scoped=true&"
import script from "./consultar-legajos.component.ts?vue&type=script&lang=ts&"
export * from "./consultar-legajos.component.ts?vue&type=script&lang=ts&"
import style0 from "./consultar-legajos.vue?vue&type=style&index=0&id=4b20513e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20513e",
  null
  
)

export default component.exports